import React, { useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import emailjs from 'emailjs-com'; 
import { Helmet } from 'react-helmet';
export default function Contact({t}) {
  const [forma, setForma] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [sending, setSending] = useState(false); 
  const [success, setSuccess] = useState(false); 
  const [messageError, setError] = useState(false); 

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        forma,
        process.env.REACT_APP_EMAILJS_USER_ID
      )
      .then(
        (response) => {
          setSuccess(true); 
          setSending(false); 
          setForma({ name: '', email: '', message: '' }); 
        },
        (err) => {
          setError(true); 
          setSending(false);
        }
      );
  };

  const handleChange = (e) => {
    setForma({
      ...forma,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[--c-light]/10 py-16 pt-[120px]">
         <Helmet>
        <title>{t.contactTitle} | [Your Website Name]</title>
        <meta
          name="description"
          content={`${t.contactSecondTitle}. Contact us for apartment rentals near Bovan Lake.`}
        />
        <meta
          name="keywords"
          content="kontakt, kontaktirajte nas, kontakt obrazac, bovan, bovansko jezero, apartmani, smestaj, izdavanje apartmana, telefon, email, adresa, rezervacije, upit, informacije"
        />
      </Helmet>
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <h1 className="text-3xl md:text-5xl font-bold text-[--c-dark] mb-4">{t.contactTitle}</h1>
          <p className="text-[--c-main] text-xl md:text-lg">{t.contactSecondTitle}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div className="bg-white p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl md:text-4xl font-semibold text-[--c-dark] mb-6">{t.contactTitle}</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-[--c-main] mb-2 text-xl" >{t.contactName}</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={forma.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-[--c-light] rounded-md focus:outline-none focus:ring-2 focus:ring-dark text-xl"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-[--c-main] mb-2 text-xl">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={forma.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-[--c-light] text-xl rounded-md focus:outline-none focus:ring-2 focus:ring-dark"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-[--c-main] mb-2 text-xl">{t.contactMessage}</label>
                <textarea
                  id="message"
                  name="message"
                  value={forma.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-4 py-2 border border-[--c-light] rounded-md text-xl focus:outline-none focus:ring-2 focus:ring-dark"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-[--c-dark] text-white py-3 rounded-md hover:bg-[--c-main] transition-colors duration-300 text-2xl"
                disabled={sending}
              >
                {sending ? `${t.contactSending}` : `${t.contactSend}`}
              </button>
            </form>
            {success && <p className="mt-4 text-green-500">{t.contactSuccess}</p>}
            {messageError && <p className="mt-4 text-red-500">{t.contactFail}</p>}
          </div>

          <div className="space-y-8">
            <div className="bg-white p-8 rounded-lg shadow-lg mb-8">
              <h2 className="text-3xl font-semibold text-[--c-dark] mb-6">{t.contactInformation}</h2>
              <div className="space-y-4 text-xl">
                <div className="flex items-center">
                  <Phone className="w-5 h-5 text-[--c-dark] mr-3" />
                  <span className="grid text-[--c-main]"><span>064 1227841 </span><span> 065 3010083</span></span>
                </div>
                <div className="flex items-center">
                  <Mail className="w-5 h-5 text-[--c-dark] mr-3" />
                  <span className="text-l break-all sm:text-xl text-[--c-main]">bellatours.nis@gmail.com</span>
                </div>
                <div className="flex items-center">
                  <MapPin className="w-5 h-5 text-[--c-dark] mr-3" />
                  <span className="text-[--c-main]">Četinarska 2, Bovan</span>
                </div>
              </div>
            </div>

            <a
              href="https://www.google.com/maps"
              target="_blank"
              rel="noopener noreferrer"
              className="block"
            > <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d46187.55564554246!2d21.63670420646667!3d43.653947207718716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475425003e7b0159%3A0x4491210acb1c5ad5!2sBella%20apartmani!5e0!3m2!1sen!2srs!4v1736196862179!5m2!1sen!2srs"
                className="w-full h-64 object-cover rounded-lg shadow-lg hover:opacity-90 transition-opacity duration-300"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map"
              ></iframe>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
